import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M12 .18v31.64c-2.279-.193-4.32-.54-5.657-1.05a8 8 0 0 1-1.01-.475V1.705a8 8 0 0 1 1.01-.476C7.679.72 9.72.373 12 .18",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M.117 12.667h31.778c.088 1.152.116 2.277.102 3.35.014 1.055-.02 2.17-.114 3.316H.107a37 37 0 0 1-.104-3.35c-.014-1.055.02-2.17.114-3.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M10.667.314v31.372c-1.565-.184-2.957-.45-4-.8V1.114c1.043-.35 2.435-.616 4-.8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.033 14h31.938q.04 1.034.026 2.016.013.964-.03 1.984H.029a38 38 0 0 1-.026-2.017c-.008-.64.001-1.304.03-1.983",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagAla = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagAla_default = SvgFlagAla;

export { FlagAla_default as default };
